module.exports = __webpack_public_path__ + "static/Illustration-ApolloReserve-7e5d4f5700e3764465c8b8dcff2fe939.svg";